import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/PageHeader";
import { Shield, User, Bell, Check } from "lucide-react";

export default function Settings() {
  const { user } = useAuth();
  return (
    <div>
      <PageHeader overline="Team" title="Settings" />
      <div className="p-8 grid lg:grid-cols-2 gap-px bg-black/10">
        <div className="bg-white p-8">
          <User className="h-6 w-6 text-primary mb-4" strokeWidth={1.5} />
          <p className="overline mb-4">Your account</p>
          <dl className="space-y-3 text-sm">
            <div className="flex justify-between border-b border-black/5 pb-2"><dt className="text-muted-foreground">Name</dt><dd>{user?.full_name}</dd></div>
            <div className="flex justify-between border-b border-black/5 pb-2"><dt className="text-muted-foreground">Email</dt><dd>{user?.email}</dd></div>
            <div className="flex justify-between border-b border-black/5 pb-2"><dt className="text-muted-foreground">Role</dt><dd className="capitalize">{user?.role}</dd></div>
            <div className="flex justify-between"><dt className="text-muted-foreground">Status</dt><dd className="text-[#10B981]">{user?.status}</dd></div>
          </dl>
        </div>
        <div className="bg-white p-8">
          <Shield className="h-6 w-6 text-primary mb-4" strokeWidth={1.5} />
          <p className="overline mb-4">Permissions & visibility</p>
          <ul className="space-y-3 text-sm text-muted-foreground">
            {[
              "Clients only see recruiter-shared candidates",
              "Candidates cannot see one another",
              "AI outputs are internal-only",
              "Company-level data isolation enforced",
            ].map((t) => (
              <li key={t} className="flex gap-2"><Check className="h-4 w-4 text-[#10B981] shrink-0 mt-0.5" /> {t}</li>
            ))}
          </ul>
        </div>
        <div className="bg-white p-8 lg:col-span-2">
          <Bell className="h-6 w-6 text-primary mb-4" strokeWidth={1.5} />
          <p className="overline mb-2">Alert rules</p>
          <p className="text-sm text-muted-foreground">Candidate job alerts and client posting notifications arrive in the paid job-posting phase.</p>
        </div>
      </div>
    </div>
  );
}
